// extracted by mini-css-extract-plugin
export default {"errorPageTextContainer":"ErrorPage_errorPageTextContainer__9CR1F","logo":"ErrorPage_logo__E0okH"};